/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_tools_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precision-engineered tools, each solving a specific problem with uncompromising quality.`)
};

const es_home_tools_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas diseñadas con precisión, cada una resolviendo un problema específico con calidad sin concesiones.`)
};

const de_home_tools_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Präzisionswerkzeuge, jedes löst ein spezifisches Problem mit kompromissloser Qualität.`)
};

const nl_home_tools_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisietools die elk een specifiek probleem oplossen met compromisloze kwaliteit.`)
};

const fr_home_tools_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des outils de précision, chacun résolvant un problème spécifique avec une qualité sans compromis.`)
};

const it_home_tools_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti di precisione, ognuno risolve un problema specifico con qualità senza compromessi.`)
};

const pt_br2_home_tools_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de precisão, cada uma resolvendo um problema específico com qualidade sem compromisso.`)
};

const pt_home_tools_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de precisão, cada uma a resolver um problema específico com qualidade sem compromissos.`)
};

const ja_home_tools_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精度ツール — それぞれが特定の問題を妥協なく解決。`)
};

const zh_home_tools_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精准工具，每一款都以毫不妥协的质量解决特定问题。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_tools_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_tools_subtitle(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_tools_subtitle", locale)
	if (locale === "en") return en_home_tools_subtitle(inputs)
	if (locale === "es") return es_home_tools_subtitle(inputs)
	if (locale === "de") return de_home_tools_subtitle(inputs)
	if (locale === "nl") return nl_home_tools_subtitle(inputs)
	if (locale === "fr") return fr_home_tools_subtitle(inputs)
	if (locale === "it") return it_home_tools_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_home_tools_subtitle(inputs)
	if (locale === "pt") return pt_home_tools_subtitle(inputs)
	if (locale === "ja") return ja_home_tools_subtitle(inputs)
	return zh_home_tools_subtitle(inputs)
};